<template>
  <RaceEventList />
</template>

<script>
import RaceEventList from "@/components/dashboard/RaceList/RaceEventList.vue";
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
  mixins: [apiCalls],
  components: {
    RaceEventList
  },
  data() {
    return {
      listData: [
        {
          eventName: "2019 Rd 7: Lead Belt National Enduro",
          eventDate: "2019-09-08",
          raceName: "Lead Belt National Enduro",
          scoringMode: "Sprint Enduro",
          trackLength: "50miles",
          startDate: "2019-09-08",
          startTime: "10:00:00",
          raceLength: "02:00:00",
          status: "Live",
          displayOnline: "Yes",
          action: "<i class='far fa-pencil-alt'></i>",
        },
      ],
      user: null,
      columns: [
          {
            title: this.$t("page.raceList.event-name"),
            field: "eventName",
            sorter: "string",
            formatter: "textarea",
            widthGrow: 2,
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceList.event-date"),
            field: "eventDate",
            sorter: "string",
            formatter: "html",
            minWidth: 110,
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceList.race-name"),
            field: "raceName",
            sorter: "string",
            formatter: "textarea",
            widthGrow: 2,
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceList.scoring-mode"),
            field: "scoringMode",
            sorter: "string",
            formatter: "textarea",
            widthGrow: 2,
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceList.track-length"),
            field: "trackLength",
            sorter: "string",
            formatter: "textarea",
            minWidth: 110,
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceList.start-date"),
            field: "startDate",
            sorter: "string",
            formatter: "textarea",
            minWidth: 110,
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceList.start-time"),
            field: "startTime",
            sorter: "string",
            formatter: "textarea",
            minWidth: 110,
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceList.race-length"),
            field: "raceLength",
            sorter: "string",
            formatter: "textarea",
            minWidth: 110,
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceList.status"),
            field: "status",
            sorter: "string",
            formatter: "textarea",
            minWidth: 85,
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceList.display-online"),
            field: "displayOnline",
            sorter: "string",
            formatter: (cell) => {
              const value = cell.getValue();
              return value === 1 || value === "1" || value === true || value === "Yes" ? 
                this.$t("common.form.yes") : 
                this.$t("common.form.no");
            },
            minWidth: 85,
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("page.raceList.action"),
            field: "action",
            sorter: "string",
            formatter: "html",
            cssClass: "text-center",
            maxWidth: 90,
            cellClick: function (e, cell) {
              //e - the click event object
              //cell - cell component
              const rowData = cell._cell.row.data;
              this.$router.push({ name: "raceDetails", params: { id : rowData.raceId }});
            }.bind(this),
          },
      ]
    };
  },
  computed: {
    tabulatorOptions: function () {
      return {
        ajaxURL: `${process.env.VUE_APP_ROOT}/laravel/public/api/v1/promoter/race/${this.user.id}`,
        ajaxResponse: function (url, params, response) {
          let data = [];
          const { message } = response;
          data = message.map((item) => {
            return {
              ...item,
              startDate: item.startDay,
              //displayOnline: item.displayFlag ? 'Yes' : 'No',
              action: "<i class='far fa-pencil-alt'></i>"
            };
          });
          return data;
        },
        layout: "fitColumns",
        height: 500,
        placeholder: this.$t("common.no_data_set"),
        resizableColumns: false,
        columns: this.columns,
      };
    },
  },
  methods: {
    async getUser() {
      const response = await this.api("get", "/api/v1/users/current");
      const { success, message } = response;
      if (success) this.user = message;
    },
  },
  mounted() {
    this.getUser();
  },
};
</script>

<style lang="scss">
</style>

